import CollapsePanel from '@BUP/components/Generics/CollapsePanel'
import styles from './historic-sociogram.module.scss'
import SurveysList from './surveys-list'

const CollapseElement = ({ year, sortedResults }) => {
  return (
    <div className='historical-collapse-element'>
      <CollapsePanel
        label={<h4 className={styles.collapse_title}>{`Año ${year}`}</h4>}
        arrowColor='#FFFFFF'
        buttonColor='#A78CD9'
        borderRadius='0.25rem'
        id={year}
        shadow
        key={year}
        borderRadiusBottom
      >
        <SurveysList results={sortedResults} />
      </CollapsePanel>
    </div>
  )
}

export default CollapseElement
